import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"20px","white-space":"nowrap"},
  class: "fas fa-info-circle"
}, null, -1)
const _hoisted_2 = { style: {"text-align":"justify"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "row justify-content-center" }
const _hoisted_7 = {
  id: "1of3from",
  class: "h4 form-control-label"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h5", null, [
      _hoisted_1,
      _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.Select vocabulary:")), 1)
    ]),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("messages.three choices")), 1),
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.translations[_ctx.displayNumber]?.fromName), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.translations, (translation) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `from${translation.fromId}to${translation.toId}`,
          class: "col my-2 text-center"
        }, [
          _createElementVNode("button", {
            id: "1of3to1",
            onClick: ($event: any) => (_ctx.check(translation)),
            class: "btn btn-primary"
          }, _toDisplayString(translation.toName), 9, _hoisted_9)
        ]))
      }), 128))
    ]),
    _hoisted_10,
    _hoisted_11
  ], 64))
}